<template>
  <v-row>
    <v-col
      cols="12"
      md="4"
    >
      <v-select
        v-model="descuento.rooms_id"
        :disabled="$store.state.app.onlyShow"
        :items="roomsFree"
        :label="$t('lbl.rooms')"
        outlined
        dense
        multiple
        hide-details
        item-text="name"
        item-value="id"
      >
        <template v-slot:no-data>
          <v-list-item>
            <v-list-item-title>
              {{ $t('lbl.rooms') }}
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-select>
    </v-col>
    <v-col
      cols="12"
      md="1"
    >
      <v-tooltip
        v-if="hotel.descuentos.length > 1 && !$store.state.app.onlyShow"
        top
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-2"
            v-bind="attrs"
            fab
            dark
            x-small
            color="error"
            v-on="on"
            @click="deleteDescuentoOfertEBB({ pos: posHotel, posDescuento: pos })"
          >
            <v-icon small>
              {{ icons.mdiTrashCan }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('btn.delete') }}</span>
      </v-tooltip>

      <v-tooltip
        v-if="pos === 0 && !$store.state.app.onlyShow"
        top
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            dark
            x-small
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="addDescuentoOfertEBB(pos)"
          >
            <v-icon small>
              {{ icons.mdiPlus }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('btn.insert') }}</span>
      </v-tooltip>
    </v-col>

    <v-col
      cols="12"
      md="6"
      offset-md="1"
      class="mt-0 pt-0"
    >
      <!--FECHA VIAJE-->
      <v-row class="mt-0">
        <v-col
          cols="12"
          md="2"
          class="mt-3"
        >
          <strong class="text-center">{{ $t('lbl.travel') }}</strong>
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <v-menu
            v-model="menuFromViaje"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedFromDateViajeFormatted"
                :label="$t('lbl.from')"
                :disabled="$store.state.app.onlyShow"
                persistent-hint
                readonly
                v-bind="attrs"
                outlined
                dense
                class="my-input mb-0"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="descuento.fromViaje"
              no-title
              :min="new Date(Date.now()).toISOString().substr(0, 10)"
              locale="es"
              :show-current="false"
              @input="
                menuFromViaje = false
                activeToDateViaje()
              "
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <v-menu
            v-model="menuToViaje"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedToDateViajeFormatted"
                :label="$t('lbl.to')"
                :disabled="descuento.fromViaje === null || $store.state.app.onlyShow"
                persistent-hint
                readonly
                v-bind="attrs"
                outlined
                dense
                class="my-input"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="descuento.toViaje"
              no-title
              locale="es"
              :show-current="false"
              :min="
                descuento.fromViaje
                  ? $moment(descuento.fromViaje)
                    .add(1, 'day')
                    .toDate()
                    .toISOString()
                    .substr(0, 10)
                  : ''
              "
              @input="menuToViaje = false"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="descuento.plan_id"
            :disabled="$store.state.app.onlyShow"
            :items="allPlanes"
            :label="$t('lbl.plan')"
            outlined
            dense
            hide-details
            item-text="siglas"
            item-value="id"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title>
                  {{ $t('lbl.plan') }}
                </v-list-item-title>
              </v-list-item>
            </template>
          </v-select>
        </v-col>
      </v-row>

      <!--DESCUENTOS-->
      <v-row class="mt-0">
        <v-col
          cols="12"
          md="3"
          offset-md="2"
          class="mt-0"
        >
          <v-text-field
            v-model="descuento.valueDescuento"
            :label="$t('lbl.descuent')"
            :disabled="$store.state.app.onlyShow"
            class="my-input"
            outlined
            dense
            hide-details
            type="number"
            :prefix="descuento.in_value_descuento ? '$' : ''"
            :suffix="!descuento.in_value_descuento ? '%' : ''"
          ></v-text-field>
        </v-col>
        <v-col
          cols="12"
          md="2"
        >
          <v-switch
            v-model="descuento.in_value_descuento"
            :disabled="$store.state.app.onlyShow"
            :label="$t('lbl.valor')"
            hide-details
            class="mt-0"
          ></v-switch>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import {
  mdiPlus,
  mdiArrowLeft,
  mdiSquareEditOutline,
  mdiDeleteOutline,
  mdiUpdate,
  mdiCalendarRange,
  mdiCancel,
  mdiDomain,
  mdiMenuDown,
  mdiMenuRight,
  mdiTrashCan,
  mdiArrowRightCircle,
  mdiArrowDownCircle,
} from '@mdi/js'

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    descuento: {
      type: Object,
    },
    // eslint-disable-next-line vue/require-default-prop
    hotel: {
      type: Object,
    },
    // eslint-disable-next-line vue/require-default-prop
    pos: {
      type: Number,
    },
    // eslint-disable-next-line vue/require-default-prop
    posHotel: {
      type: Number,
    },
    // eslint-disable-next-line vue/require-default-prop
    allRooms: {
      type: Array,
    },
    // eslint-disable-next-line vue/require-default-prop
    hotelRooms: {
      type: Array,
    },
    // eslint-disable-next-line vue/require-default-prop
    allPlanes: {
      type: Array,
    },
  },
  data() {
    return {
      rutaPublic: process.env.VUE_APP_API_URL_PLUBLIC,
      isLoading: true,
      icons: {
        mdiPlus,
        mdiArrowLeft,
        mdiSquareEditOutline,
        mdiDeleteOutline,
        mdiUpdate,
        mdiCalendarRange,
        mdiCancel,
        mdiDomain,
        mdiMenuDown,
        mdiMenuRight,
        mdiTrashCan,
        mdiArrowRightCircle,
        mdiArrowDownCircle,
      },
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD',
      },
      modelTimeConfig: {
        type: 'string',
        mask: 'HH:mm',
      },
      loading: false,
      permisos: sessionStorage.getItem('permisos_auth'),
      itemsRooms: [],
      calculators: [],
      menuFromViaje: false,
      menuToViaje: false,
      menuFromReserva: false,
      menuToReserva: false,
      menuRooming: false,
      menuFromPagar: false,
      menuFecha: false,
    }
  },
  computed: {
    ...mapState({
      ofertasSeasonContrateHotel: state => state.app.ofertasSeasonContrateHotel,
      roomsSeasonContrateHotel: state => state.app.roomsSeasonContrateHotel,
    }),
    roomsFree() {
      const result = []
      this.allRooms.forEach(element => {
        if (this.hotelRooms.includes(element.id)) {
          result.push(element)
        }
      })

      return result
    },
    computedFromDateViajeFormatted() {
      return this.descuento.fromViaje ? this.$moment(this.descuento.fromViaje).format('D-MMM-YY') : ''
    },
    computedToDateViajeFormatted() {
      return this.descuento.toViaje ? this.$moment(this.descuento.toViaje).format('D-MMM-YY') : ''
    },
  },
  created() {
    if (this.roomsFree.length === 1) {
      this.descuento.rooms_id = [this.roomsFree[0].id]
    }
  },
  methods: {
    ...mapMutations(['deleteDescuentoOfertEBB', 'addDescuentoOfertEBB']),
    activeToDateViaje() {
      setTimeout(() => {
        // this.$refs.dateToViaje.focus()
        this.menuToViaje = true
      }, 100)
    },
  },
}
</script>
<style scoped>
::v-deep .my-input .v-label,
::v-deep .my-input input {
  font-size: 12px !important;
  line-height: 1;
  min-height: 8px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
::v-deep .v-text-field__details {
  padding: 0 0 0 0;
}

::v-deep .my-input select {
  font-size: 12px !important;
  line-height: 1;
  min-height: 8px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
</style>
